import moment from 'moment';
import { addOrderToPreview} from '../../../slices/orderManagement/previewOrder/reducer'

export const handleAddItem = (values, selectedOffer, formData, navigate,subscriptionId, dispatch,resourceOverrides) => {
    dispatch(addOrderToPreview({...selectedOffer,subscriptionID:subscriptionId?subscriptionId: values.subscriptionID,quantity:1,resourceOverrides:resourceOverrides}))
    const dataToSend = {
        serviceName: selectedOffer?.serviceName,
        offerName: selectedOffer?.offerName,
        offerCode: selectedOffer?.offerCode,
        termValidity: selectedOffer?.termValidity,
        validityFrom: selectedOffer?.validityFrom,
        validityTo: selectedOffer?.validityTo,
        totalChargeAmount: selectedOffer?.totalChargeAmount,
        unitPrice: selectedOffer?.unitPrice,
        subTotal:selectedOffer?.subTotal,
        description: selectedOffer?.description,
        CustomerId: selectedOffer?.CustomerId,
        CustomerName: selectedOffer?.CustomerName,
        ProvisionalAttributes: selectedOffer?.provisioningAttributes,
        orderId:selectedOffer?.orderId,
        resourceOverrides: resourceOverrides,
        formData: {
            subscriptionID:subscriptionId ? subscriptionId: values?.subscriptionID,
            selectedOffer: values.selectedOffer,
            selectedDevice: values.selectDevice.value,
            subscriptionStartsOn: moment(values.subscriptionStartsOn).format('MMM DD, YYYY'),
            subscriptionEndsOn: moment(values.subscriptionEndsOn).format('MMM DD, YYYY'),
            name: formData.name,
            value: formData.value,
        },
    };
    
    navigate('/order-details', { state: { ...dataToSend } });
};
